export class CoreUrlProvider {
  private static readonly _apiBackendUrl: string = '/api/backend';
  private static readonly _apiOrganisationUrl: string = '/api/organisation';
  static readonly URL = {
    ADMIN: {
      LOGS: `/api/backend/admin-area/event-log`,
      SETTINGS: `/api/backend/admin-area/application-property`,
    },
    AUTH: {
      LOGOUT: `/oidc/connect/logout`,
      USER_ME: `${CoreUrlProvider._apiOrganisationUrl}/user/me`,
      USER_ME_PASSWORD: `${CoreUrlProvider._apiOrganisationUrl}/user/me/password`,
      USER_DETAILS: `${CoreUrlProvider._apiOrganisationUrl}/user/{userUuid}/security-details`,
    },
    SCENARIOS: {
      LIST: `${CoreUrlProvider._apiBackendUrl}/scenario?filter_str_name={name}&sort_{column}={dir}&page={page}&sizeOfPage={size}&filter_str_tags={tags}&filter_str_folderParentUuid={folder}`,
      RUN: `${CoreUrlProvider._apiBackendUrl}/scenario/results`,
      RESULT: `${CoreUrlProvider._apiBackendUrl}/scenario/{uuid}/results`,
      RETENTION: `${CoreUrlProvider._apiBackendUrl}/scenario/{uuid}/retention`,
      RETENTION_CONFIGURATION: `${CoreUrlProvider._apiBackendUrl}/scenario/{uuid}/retention/configuration`,
      BASE: `${CoreUrlProvider._apiBackendUrl}/scenario/{uuid}`,
      CREATE: `${CoreUrlProvider._apiBackendUrl}/scenario`,
      SANKEY: `${CoreUrlProvider._apiBackendUrl}/scenario/sankey/{uuid}/{nodeName}/{bucketName}`,
      SCENARIO_SANKEY_RESULT: `${CoreUrlProvider._apiBackendUrl}/scenario/{uuid}/sankey`,
      SCENARIO_SANKEY_REQUEST: `${CoreUrlProvider._apiBackendUrl}/scenario/{uuid}/sankey/{nodeName}/{bucketName}`,
      RETENTION_LIST: `${CoreUrlProvider._apiBackendUrl}/scenario/retention?filter_str_name={name}&sort_{column}={dir}&page={page}&sizeOfPage={size}&filter_str_tags={tags}&filter_str_folderParentUuid={folder}`,
    },
    DASHBOARDS: {
      EXPECTED_SERVICE_LIST: `${CoreUrlProvider._apiBackendUrl}/dashboard/expected-service?page={page}&sizeOfPage={size}&filter_str_tags={tags}&sort_{column}={dir}`,
    },
    USERS: {
      BASE: `${CoreUrlProvider._apiOrganisationUrl}/user`,
      BASE_UUID: `${CoreUrlProvider._apiOrganisationUrl}/user/{uuid}`,
      UNLOCK: `${CoreUrlProvider._apiOrganisationUrl}/user/{uuid}/unlock`,
    },
    RELEASE_NOTES: {
      SYSTEM: `../assets/release-notes/application-release-notes.json`,
      MODEL: `../assets/release-notes/model-release-notes.json`,
      USER_MANUAL: `../assets/user-manual/XSRUserManual.pdf`,
    },
    CACHE: {
      BASE: `${CoreUrlProvider._apiBackendUrl}/cache/authenticated-user-cache/{uuid}`,
    },
    SSE: {
      BASE: `${CoreUrlProvider._apiBackendUrl}/scenario/result/subscribe`,
    },
    MODELS: {
      BASE: `${this._apiBackendUrl}/model`,
      BASE_UUID: `${this._apiBackendUrl}/model/{uuid}`,
      SHORT: `${this._apiBackendUrl}/model/short`,
      NETWORK: `${CoreUrlProvider._apiBackendUrl}/model/{uuid}/graph`,
    },
    TAGS: {
      BASE: `${this._apiBackendUrl}/tag`,
    },
    FOLDER_STRUCTURE: {
      BASE: `${CoreUrlProvider._apiBackendUrl}/folder-structure`,
      BASE_UUID: `${CoreUrlProvider._apiBackendUrl}/folder-structure/{uuid}`,
      RENAME: `${CoreUrlProvider._apiBackendUrl}/folder-structure/{uuid}/rename`,
      ROOT: `${CoreUrlProvider._apiBackendUrl}/folder-structure/root`,
      MOVE: `${CoreUrlProvider._apiBackendUrl}/folder-structure/{uuid}/move`,
    },
  };
}
